import { FRONT_WARNING } from '@app/constants';
import type { NUtils } from '@app/types';

export const correctRangeValues: NUtils.CorrectRangeValues = ({
  inputStart,
  inputEnd,
  cbToSaveStartValue,
  cbToSaveEndValue,
  cbToSaveBothValues,
  showNotification,
}): void => {
  let valueType: 'dateAsStr' | 'timeAsStr' | null = null;
  let outputStartInMs: number | null = null;
  let outputEndInMs: number | null = null;
  let isIncorrectInterval = false;

  let checkedOutputStart: NUtils.InputValueToCorrectRange = inputStart;
  let checkedOutputEnd: NUtils.InputValueToCorrectRange = inputEnd;

  const showErr = (err: string): void => showNotification(err, FRONT_WARNING);

  if (!inputStart || !inputEnd) return;

  if (typeof inputStart !== typeof inputEnd)
    return showErr('Типы границ интервала не должны отличаться');

  const shortDateRegExp = /\d{4}-\d{2}-\d{2}/g;
  const middleDateRegExp = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/g;
  const fullDateRegExp = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+]\d{4}/g;

  const isDateInISO8601 =
    inputStart.match(shortDateRegExp) ||
    inputStart.match(middleDateRegExp) ||
    inputStart.match(fullDateRegExp);

  if (typeof inputStart === 'string') {
    if (isDateInISO8601) {
      valueType = 'dateAsStr';
    }
  }

  if (valueType === 'dateAsStr') {
    outputStartInMs = new Date(inputStart).getTime();
    outputEndInMs = new Date(inputEnd).getTime();
  }

  const hasNegativeDiff =
    outputEndInMs && outputStartInMs && outputEndInMs - outputStartInMs < 0;

  if (valueType === 'dateAsStr' && hasNegativeDiff) {
    isIncorrectInterval = true;
  }

  if (!isIncorrectInterval) return;

  checkedOutputStart = inputEnd;
  checkedOutputEnd = inputStart;

  const hasLogicToSaveNewInterval =
    (cbToSaveStartValue && cbToSaveEndValue) || cbToSaveBothValues;
  const hasUnusedLogic =
    cbToSaveBothValues && (cbToSaveStartValue || cbToSaveEndValue);

  if (!hasLogicToSaveNewInterval)
    return showErr('Отсутствует логика для автозамены интервала дат/времени');

  if (hasUnusedLogic)
    return showErr(
      'Передана неиспользуемая логика сохранения интервала дат/времени'
    );

  if (cbToSaveStartValue && cbToSaveEndValue) {
    cbToSaveStartValue(checkedOutputStart);
    cbToSaveEndValue(checkedOutputEnd);
  }

  if (cbToSaveBothValues) {
    cbToSaveBothValues([checkedOutputStart, checkedOutputEnd]);
  }
};
